import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface AssinanteRequestDTO {
    nomeAssinante: string;
    funcaoAssinante: string;
    statusAssinante?: boolean; // Opcional para criação
    sequenciaAssinante: number; // Opcional
}

export interface AssinanteResponseDTO {
    id: number;
    nomeAssinante: string;
    funcaoAssinante: string;
    statusAssinante: boolean;
    sequenciaAssinante: number;
    createdAt: string; // ISO DateTime string
    updatedAt?: string; // ISO DateTime string
    deletedAt?: string; // ISO DateTime string
}

@Injectable({
    providedIn: 'root'
})
export class SignerService {

    private apiUrl = environment.apiUrl;
    private readonly baseUrl = `${this.apiUrl}/nucon/api/v1/assinantes`;
  
    
    private readonly httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient) {}

    criar(requestDTO: AssinanteRequestDTO): Observable<AssinanteResponseDTO> {
        //console.log('Criando assinante:', requestDTO);
        return this.http.post<AssinanteResponseDTO>(this.baseUrl, requestDTO, this.httpOptions);
    }

    alterar(id: number, requestDTO: AssinanteRequestDTO): Observable<AssinanteResponseDTO> {
        //console.log('Alterando assinante:', id, requestDTO);
        return this.http.put<AssinanteResponseDTO>(`${this.baseUrl}/${id}`, requestDTO, this.httpOptions);
    }

    alterarStatus(id: number, statusAssinante: boolean): Observable<AssinanteResponseDTO> {
        return this.http.patch<AssinanteResponseDTO>(`${this.baseUrl}/${id}/status`, 
            { statusAssinante }, this.httpOptions);
    }

    // Método usando os endpoints específicos ativar/inativar
    alterarStatusEspecifico(id: number, statusAssinante: boolean): Observable<AssinanteResponseDTO> {
        if (statusAssinante) {
            return this.ativar(id);
        } else {
            return this.inativar(id);
        }
    }

    ativar(id: number): Observable<AssinanteResponseDTO> {
        return this.http.patch<AssinanteResponseDTO>(`${this.baseUrl}/${id}/ativar`, null);
    }

    inativar(id: number): Observable<AssinanteResponseDTO> {
        return this.http.patch<AssinanteResponseDTO>(`${this.baseUrl}/${id}/inativar`, null);
    }

    obterPorId(id: number): Observable<AssinanteResponseDTO> {
        return this.http.get<AssinanteResponseDTO>(`${this.baseUrl}/${id}`);
    }

    buscarPorId(id: number): Observable<AssinanteResponseDTO> {
        return this.http.get<AssinanteResponseDTO>(`${this.baseUrl}/${id}`);
    }

    listarAtivos(): Observable<AssinanteResponseDTO[]> {
        return this.http.get<AssinanteResponseDTO[]>(this.baseUrl);
    }

    listarPorStatus(statusAssinante: boolean): Observable<AssinanteResponseDTO[]> {
        return this.http.get<AssinanteResponseDTO[]>(`${this.baseUrl}/status/${statusAssinante}`);
    }

    buscarPorFuncao(funcao: string): Observable<AssinanteResponseDTO[]> {
        return this.http.get<AssinanteResponseDTO[]>(`${this.baseUrl}/funcao`, {
            params: { funcao }
        });
    }

    listarTodos(): Observable<AssinanteResponseDTO[]> {
        //console.log('Fazendo requisição para:', this.baseUrl);
        return this.http.get<AssinanteResponseDTO[]>(this.baseUrl);
    }

    // Métodos alternativos para teste
    listarTodosAlternativo1(): Observable<any> {
        //console.log('Testando endpoint alternativo /list');
        return this.http.get<any>(`${this.baseUrl}/list`);
    }

    listarTodosAlternativo2(): Observable<any> {
        //console.log('Testando endpoint alternativo /all');
        return this.http.get<any>(`${this.baseUrl}/all`);
    }

    excluir(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }

    restaurar(id: number): Observable<AssinanteResponseDTO> {
        return this.http.patch<AssinanteResponseDTO>(`${this.baseUrl}/${id}/restaurar`, null);
    }
}